export default "__VITE_ASSET__B9kuGR73__"